(()=>{
  const videos=()=>[...document.querySelectorAll('.ll-home-player video,.ll-home-project-video')];
  function start(v){
    if(!v.getAttribute('src')){v.src=v.dataset.src;v.querySelectorAll('track[data-src]').forEach(t=>t.src=t.dataset.src);}
    videos().filter(x=>x!==v).forEach(x=>x.pause());v.hidden=false;
    v.play().catch(()=>{});
  }
  document.querySelectorAll('.ll-home-player').forEach(d=>{
    if(d.dataset.bound)return;d.dataset.bound='true';
    const v=d.querySelector('video'),label=d.querySelector('[data-open-label]'),initial=label.textContent;
    d.addEventListener('toggle',()=>{label.textContent=d.open?'Close film':initial;if(d.open)start(v);else v.pause();});
    v.addEventListener('play',()=>videos().filter(x=>x!==v).forEach(x=>x.pause()));
    v.addEventListener('error',()=>{const e=d.querySelector('.ll-home-error');e.hidden=false;e.textContent='The film could not load. Please refresh and try again.';});
  });
  document.querySelectorAll('.ll-home-project').forEach(p=>{
    if(p.dataset.bound)return;p.dataset.bound='true';
    const room=p.querySelector('.ll-home-room'),v=p.querySelector('video'),close=p.querySelector('.ll-home-project-close');
    p.querySelector('.ll-home-project-play').addEventListener('click',()=>{room.hidden=true;close.hidden=false;start(v);});
    close.addEventListener('click',()=>{v.pause();v.hidden=true;room.hidden=false;close.hidden=true;p.querySelector('.ll-home-project-play').focus({preventScroll:true});});
    v.addEventListener('play',()=>videos().filter(x=>x!==v).forEach(x=>x.pause()));
    v.addEventListener('error',()=>{const e=p.querySelector('.ll-home-error');e.hidden=false;e.textContent='The film could not load. Please refresh and try again.';});
  });
  window.addEventListener('pagehide',()=>videos().forEach(v=>v.pause()));
})();
